"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestion = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const PerformQuestionController_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const react_1 = __importStar(require("react"));
const react_intersection_observer_1 = require("react-intersection-observer");
const OpPerform_1 = require("../OpPerform");
const OpPerformFakeQuestion_1 = require("./OpPerformFakeQuestion");
const OpPerformQuestionAsset_1 = __importDefault(require("./types/OpPerformQuestionAsset"));
const OpPerformQuestionCheck_1 = __importDefault(require("./types/OpPerformQuestionCheck"));
const OpPerformQuestionDateTime_1 = __importDefault(require("./types/OpPerformQuestionDateTime"));
const OpPerformQuestionInfo_1 = __importDefault(require("./types/OpPerformQuestionInfo"));
const OpPerformQuestionIssue_1 = __importDefault(require("./types/OpPerformQuestionIssue"));
const OpPerformQuestionList_1 = __importDefault(require("./types/OpPerformQuestionList"));
const OpPerformQuestionNumber_1 = __importDefault(require("./types/OpPerformQuestionNumber"));
const OpPerformQuestionPhoto_1 = __importDefault(require("./types/OpPerformQuestionPhoto"));
const OpPerformQuestionQSet_1 = __importDefault(require("./types/OpPerformQuestionQSet"));
const OpPerformQuestionRating_1 = __importDefault(require("./types/OpPerformQuestionRating"));
const OpPerformQuestionRepetition_1 = __importDefault(require("./types/OpPerformQuestionRepetition"));
const OpPerformQuestionSection_1 = __importDefault(require("./types/OpPerformQuestionSection"));
const OpPerformQuestionSignature_1 = __importDefault(require("./types/OpPerformQuestionSignature"));
const OpPerformQuestionSPT_1 = __importDefault(require("./types/OpPerformQuestionSPT"));
const OpPerformQuestionText_1 = __importDefault(require("./types/OpPerformQuestionText"));
const OpPerformQuestion = (props, ref) => {
    const { questionNode, highlightSelected } = props;
    const { form } = (0, usePerform_1.default)();
    const { ref: inViewRef, inView } = (0, react_intersection_observer_1.useInView)({ threshold: 0 });
    const indent = (0, OpPerform_1.getIndent)(form, questionNode);
    const { nodeId, questionId } = questionNode;
    const rule = form.rules[questionId];
    const hideIfNotInView = false; // type !== FQT.REPETITION && type !== FQT.SECTION && type !== FQT.INFO
    const hide = hideIfNotInView && !inView;
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { ref: hideIfNotInView ? inViewRef : undefined },
        react_1.default.createElement(PerformQuestionController_1.default, { questionNodeId: nodeId, indent: indent, disabled: hide },
            hide && react_1.default.createElement(OpPerformFakeQuestion_1.OpPerformFakeQuestion, { questionNode: questionNode, rule: rule }),
            !hide && (react_1.default.createElement(OpPerformQuestionInner, Object.assign({ disabled: !inView, highlightSelected: highlightSelected, ref: ref }, props)))))), [
        hideIfNotInView,
        inViewRef,
        nodeId,
        indent,
        hide,
        questionNode,
        rule,
        inView,
        highlightSelected,
        ref,
        props,
    ]);
};
exports.OpPerformQuestion = OpPerformQuestion;
const OpPerformQuestionInner = (0, react_1.forwardRef)((props, ref) => {
    const { highlightSelected = false } = props;
    const { question, selected } = (0, usePerformQuestion_1.default)();
    const wasSelected = (0, react_1.useRef)(selected);
    const type = question === null || question === void 0 ? void 0 : question.type;
    const outerRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (highlightSelected && wasSelected.current !== selected) {
            wasSelected.current = selected;
            (_b = (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoViewIfNeeded) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [highlightSelected, selected]);
    const content = (0, react_1.useMemo)(() => {
        switch (type) {
            case FormQuestionType_1.default.ASSET:
                return react_1.default.createElement(OpPerformQuestionAsset_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.CHECK:
                return react_1.default.createElement(OpPerformQuestionCheck_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.DATETIME:
                return react_1.default.createElement(OpPerformQuestionDateTime_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.INFO:
                return react_1.default.createElement(OpPerformQuestionInfo_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.ISSUE:
                return react_1.default.createElement(OpPerformQuestionIssue_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.LIST:
                return react_1.default.createElement(OpPerformQuestionList_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.NUMBER:
                return react_1.default.createElement(OpPerformQuestionNumber_1.default, Object.assign({}, props));
            // -----------------
            // PAUSE DEPRECATION
            // case FormQuestionType.PAUSE:
            // 	return <OpPerformQuestionPause />
            // -----------------
            case FormQuestionType_1.default.PHOTO:
                return react_1.default.createElement(OpPerformQuestionPhoto_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.RATING:
                return react_1.default.createElement(OpPerformQuestionRating_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.REPETITION:
                return react_1.default.createElement(OpPerformQuestionRepetition_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.QUESTIONSET:
                return react_1.default.createElement(OpPerformQuestionQSet_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.SECTION:
                return react_1.default.createElement(OpPerformQuestionSection_1.default, Object.assign({ ref: ref }, props));
            case FormQuestionType_1.default.SIGNATURE:
                return react_1.default.createElement(OpPerformQuestionSignature_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.SPT:
                return react_1.default.createElement(OpPerformQuestionSPT_1.default, Object.assign({}, props));
            case FormQuestionType_1.default.TEXT:
                return react_1.default.createElement(OpPerformQuestionText_1.default, Object.assign({}, props));
        }
    }, [props, ref, type]);
    return (0, react_1.useMemo)(() => {
        return react_1.default.createElement("div", { ref: outerRef }, content);
    }, [content]);
});
exports.default = (0, react_1.forwardRef)(exports.OpPerformQuestion);
